import React from 'react'
import PropTypes from 'prop-types'
import './SigninLayout.css'
import { withStyles } from '@material-ui/core/styles'
export const SigninLayout = ({ children, theme }) => (
  <div
    style={{ backgroundColor: theme.palette.primary.light }}
    className="boardingPage">
    {children}
  </div>
)
SigninLayout.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node
}

export default withStyles({}, { withTheme: true })(SigninLayout)



// WEBPACK FOOTER //
// ./src/layouts/SigninLayout/SigninLayout.js